require('../../../modules/es.array.slice');
var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('Array').slice;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/array/virtual/slice.js
// module id = 979
// module chunks = 0